import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './progress-container.styles';
import ProgressContainer from './progress-container';

export default compose(withStyles(styles))(ProgressContainer);
